<form [formGroup]="readyProductForm" (submit)="onSubmit()">
  <div class="w-full lg:flex lg:flex-wrap xl:flex-nowrap items-start lg:gap-3">
    <div class="w-full lg:w-full xl:w-1/3 mb-4 lg:mb-0">
      <div
        class="w-full bg-[#FFFFF6] p-3 rounded-md grid grid-cols-1 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-2 gap-2 sm:gap-2.5 lg:gap-3 space-y-0.5">

        <div class="col-span-1">
          <div class="relative">
            <select formControlName="rproduct_categories" (change)="onCategorySelected($any($event.target).value)"
              class="block w-full px-2 py-2 text-sm lg:text-sm text-444 font-normal bg-white rounded-md border-1 border-dcdcdc appearance-none focus:outline-none focus:ring-0 focus:border-c19725">
              <option value="" selected hidden disabled>Select Category</option>
              <option *ngFor="let category of prodCategory" [value]="category.id">
                {{ category.name }} (#{{ category.unit}})
              </option>
            </select>
          </div>
          <!-- Validation Error (NO layout change) -->
          <div
            *ngIf="readyProductForm.get('rproduct_categories')?.invalid && readyProductForm.get('rproduct_categories')?.touched"
            class="text-red-500 text-xs mt-1">
            *Product category is required
          </div>
        </div>

        <div class="col-span-1">
          <div class="relative">
            <input autocomplete="off" readonly type="text" id="category_code" formControlName="category_code"
              class="block px-2 py-2 w-full text-sm lg:text-sm text-444 font-normal bg-gray-50 rounded-md border-1 border-dcdcdc appearance-none focus:outline-none focus:ring-0 focus:border-c19725 peer"
              placeholder=" " />
            <label for="category_code"
              class="absolute text-sm lg:text-sm text-[#898989] duration-300 transform -translate-y-4 scale-75 top-2 z-0 origin-[0] bg-white px-1.5 peer-focus:px-1.5 peer-focus:text-c19725 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1">
              Category Code
            </label>
          </div>
        </div>


        <!-- <div class="col-span-1">
                    <app-custom-select label="Sub Categories" [options]="subCategory" formControlName="rproduct_subcategories" (keydown.enter)="focusNext($event)"
                        [(selected)]="selectedSubCategory" selectId="subCategory">
                    </app-custom-select>
                  </div> -->

        <div class="col-span-1">
          <div class="relative">
            <input autocomplete="off" readonly type="text" id="rproduct_code" formControlName="rproduct_code"
              (focus)="onFocusProductCode()" (blur)="onBlurProductCode()" (input)="onInputProductCode($event)"
              (keydown)="onCodeKeyDown($event)" (keydown.enter)="focusNext($event)"
              class="block px-2 py-2 w-full text-sm lg:text-sm text-444 font-normal bg-white rounded-md border-1 border-dcdcdc appearance-none focus:outline-none focus:ring-0 focus:border-c19725 peer"
              placeholder=" " autocomplete="off" />

            <label for="rproduct_code"
              class="absolute text-sm lg:text-sm text-[#898989] duration-300 transform -translate-y-4 scale-75 top-2 z-0 origin-[0] bg-white px-1.5 peer-focus:px-1.5 peer-focus:text-c19725 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1">
              Lot Number
            </label>

            <!-- Dropdown -->
            <ul *ngIf="showDropdown && filteredProductCodes.length"
              class="absolute z-10 w-full bg-white border border-gray-300 max-h-40 overflow-y-auto rounded shadow-md">
              <li *ngFor="let code of filteredProductCodes; let i = index" (mousedown)="onSelectProductCode(code)"
                [class.code-list-item]="true" [class.bg-gray-200]="i === activeCodeIndex"
                class="px-3 py-2 text-sm cursor-pointer hover:bg-gray-100">
                {{ code }}
              </li>
            </ul>
          </div>
        </div>
        <div class="col-span-1">
          <div class="relative max-w-sm">
            <input id="date" type="text" formControlName="rproduct_date" (keydown.enter)="focusNext($event)"
              autocomplete="off"
              class="block px-2 py-2 w-full text-sm lg:text-sm text-444 font-normal bg-white rounded-md border-1 border-dcdcdc appearance-none focus:outline-none focus:ring-0 focus:border-c19725 peer"
              placeholder="" />
            <div class="absolute inset-y-0 end-0 flex items-center pe-1 pointer-events-none">
              <svg class="size-6" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M18.9773 3.67371H4.02272C3.48663 3.67491 2.97284 3.8884 2.59376 4.26748C2.21469 4.64655 2.0012 5.16034 2.0012 5.69644V20.651C2.0012 21.1871 2.21469 21.7009 2.59376 22.0799C2.97284 22.459 3.48663 22.6725 4.02272 22.6737H18.9773C19.5134 22.6725 20.0272 22.459 20.4062 22.0799C20.7853 21.7009 20.9988 21.1871 21 20.651V5.69644C20.9988 5.16034 20.7853 4.64655 20.4062 4.26748C20.0272 3.8884 19.5134 3.67491 18.9773 3.67371Z"
                  stroke="#C19725" stroke-miterlimit="10" stroke-linecap="round" />
                <path d="M6.06836 9.59113H10.8865" stroke="#C19725" stroke-miterlimit="10" stroke-linecap="round" />
                <path d="M6.06836 13.2744H16.5002" stroke="#C19725" stroke-miterlimit="10" stroke-linecap="round" />
                <path d="M8.56836 2.5V6.44491" stroke="#C19725" stroke-miterlimit="10" stroke-linecap="round" />
                <path d="M14.4326 2.5V6.44491" stroke="#C19725" stroke-miterlimit="10" stroke-linecap="round" />
              </svg>
            </div>
            <label for=""
              class="capitalize absolute text-sm lg:text-sm text-[#898989] duration-300 transform -translate-y-4 scale-75 top-2 z-0 origin-[0] bg-white px-1.5 peer-focus:px-1.5 peer-focus:text-c19725 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1">Date</label>
          </div>
        </div>
        <div class="col-span-1">
          <app-custom-select label="Unit" [options]="saleUnit" [(selected)]="selectedSaleUnit"
            formControlName="rproduct_unit" (keydown.enter)="focusNext($event)" selectId="saleUnit">
          </app-custom-select>
        </div>
        <!-- <div class="col-span-1">
                  <div class="relative">
                    <select
                      formControlName="rproduct_firm_id"
                      (keydown.enter)="focusNext($event)"
                      name="firmType"
                      id="rproduct_firm_id"
                      class="block pl-2 pr-6 py-2 w-full text-sm lg:text-sm text-444 capitalize font-normal bg-white rounded-lg border-1 border-dcdcdc appearance-none !bg-none focus:outline-none focus:ring-0 focus:border-c19725 peer"
                    >
                      <option value="" disabled selected>Select firm</option>
                      <option *ngFor="let firm of firmTypes" [value]="firm.id">
                        {{ firm.name }}
                      </option>
                    </select>

                    <div
                      class="absolute inset-y-0 right-2 flex items-center pointer-events-none"
                    >
                      <svg
                        width="14"
                        height="7"
                        viewBox="0 0 14 7"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M7.00004 7.00016L0.333374 0.333496H13.6667L7.00004 7.00016Z"
                          fill="#C19725"
                        />
                      </svg>
                    </div>
                    <label
                      for="rproduct_firm_id"
                      class="absolute text-sm lg:text-sm text-[#898989] duration-300 transform -translate-y-4 scale-75 top-2 z-0 origin-[0] bg-white px-1.5 peer-focus:px-1.5 peer-focus:text-c19725 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1"
                      >Firm</label
                    >
                  </div>
                  </div> -->

        <!-- <div class="col-span-1 sm:col-span-2 md:col-span-1 relative">
          <input type="text" id="supplier_name" formControlName="rproduct_supplier_name"
            [(ngModel)]="supplierSearchText" (input)="filterSuppliers()" (keydown)="sNameHandleKeyDown($event)"
            (focus)="sNameShowDropdown = true" (blur)="sNameHideDropdown()" autocomplete="off" placeholder=" "
            class="block px-2 py-2 w-full text-sm text-444 font-normal bg-white rounded-md border border-dcdcdc focus:outline-none focus:ring-0 focus:border-c19725 peer" />

          <label for="supplier_name"
            class="absolute text-sm text-[#898989] duration-300 transform -translate-y-4 scale-75 top-2 z-0 origin-[0] bg-white px-1.5 peer-focus:text-c19725 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 start-1">
            Supplier Name
          </label> -->

        <!-- Search Dropdown -->
        <!-- <ul *ngIf="sNameShowDropdown && filteredSuppliers.length > 0"
            class="absolute z-10 w-full bg-white border border-gray-300 rounded shadow-md max-h-40 overflow-y-auto">
            <li #supplierItem *ngFor="let supplier of filteredSuppliers; let i = index" [ngClass]="{
                          'bg-c19725 text-white': i === activeIndex,
                          'cursor-pointer hover:bg-gray-100': true
                        }" class="px-3 py-1 text-sm" (click)="selectSupplier(i, supplier)">
              {{ supplier.name }}
            </li>
          </ul>
        </div> -->

        <!-- <div class="col-span-1">
                      <div class="relative">
                          <input type="text" id="supplier_code" formControlName="rproduct_supplier_code" (keydown.enter)="focusNext($event)" autocomplete="off"
                              class="block px-2 py-2 w-full text-sm lg:text-sm text-444 font-normal bg-white rounded-md border-1 border-dcdcdc appearance-none focus:outline-none focus:ring-0 focus:border-c19725 peer"
                              placeholder=" " />
                          <label for="supplier_code"
                              class="absolute text-sm lg:text-sm text-[#898989] duration-300 transform -translate-y-4 scale-75 top-2 z-0 origin-[0] bg-white px-1.5 peer-focus:px-1.5 peer-focus:text-c19725 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1">Supplier
                              Code</label>
                      </div>
                  </div> -->

        <!-- <div class="col-span-1 sm:col-span-2 md:col-span-1 ">
                      <div class="relative">
                          <input type="text" id="supplier_product_code" formControlName="rproduct_supplier_product_code" (keydown.enter)="focusNext($event)" autocomplete="off"
                              class="block px-2 py-2 w-full text-sm lg:text-sm text-444 font-normal bg-white rounded-md border-1 border-dcdcdc appearance-none focus:outline-none focus:ring-0 focus:border-c19725 peer"
                              placeholder=" " />
                          <label for="supplier_product_code"
                              class="absolute text-sm lg:text-sm text-[#898989] duration-300 transform -translate-y-4 scale-75 top-2 z-0 origin-[0] bg-white px-1.5 peer-focus:px-1.5 peer-focus:text-c19725 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1">Supplier
                              Product Code</label>
                      </div>
                  </div> -->
      </div>
    </div>
    <div class="w-full lg:w-full xl:w-1/3 mb-4 lg:mb-0">
      <div
        class="w-full bg-[#F1F8FF] p-3 rounded-md grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-2 gap-2 sm:gap-2.5 lg:gap-3 space-y-0.5 mb-4">
        <!-- <div class="col-span-1">
          <div class="relative">
            <input type="number" appOnlyNumber id="rproduct_silver_rate_per_gm" formControlName="rproduct_silver_rate_per_gm"
              (keydown.enter)="focusNext($event)" autocomplete="off"
              class="no-spinner block px-2 py-2 w-full text-sm lg:text-sm text-444 font-normal bg-white rounded-md border-1 border-dcdcdc appearance-none focus:outline-none focus:ring-0 focus:border-c19725 peer"
              placeholder=" " />
            <label for="rproduct_silver_rate_per_gm"
              class="absolute text-sm lg:text-sm text-[#898989] duration-300 transform -translate-y-4 scale-75 top-2 z-0 origin-[0] bg-white px-1.5 peer-focus:px-1.5 peer-focus:text-c19725 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1">Silver
              Rate Per Gram</label>
          </div>
        </div> -->

        <div class="col-span-1">
          <div class="relative">
            <input type="number" id="rproduct_per_gram_labour" formControlName="rproduct_per_gram_labour"
              (keydown.enter)="focusNext($event)" autocomplete="off"
              class="no-spinner px-2 py-2 w-full text-sm lg:text-sm text-444 font-normal bg-white rounded-md border-1 border-dcdcdc appearance-none focus:outline-none focus:ring-0 focus:border-c19725 peer"
              placeholder=" " />
            <label for="rproduct_per_gram_labour"
              class="absolute text-sm lg:text-sm text-[#898989] duration-300 transform -translate-y-4 scale-75 top-2 z-0 origin-[0] bg-white px-1.5 peer-focus:px-1.5 peer-focus:text-c19725 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1">Per
              Gram Labour <span class="text-red-500">*</span></label>
          </div>
          <!-- Validation Error (NO layout change) -->
          <div *ngIf="
      readyProductForm.get('rproduct_per_gram_labour')?.invalid &&
      readyProductForm.get('rproduct_per_gram_labour')?.touched
    " class="text-red-500 text-xs mt-1">
            *Per Gram Labour is required
          </div>
        </div>

        <div class="col-span-1">
          <div class="relative">
            <input type="number" id="rproduct_shipping_per_gm" formControlName="rproduct_shipping_per_gm"
              (keydown.enter)="focusNext($event)" autocomplete="off"
              class="no-spinner px-2 py-2 w-full text-sm lg:text-sm text-444 font-normal bg-white rounded-md border-1 border-dcdcdc appearance-none focus:outline-none focus:ring-0 focus:border-c19725 peer"
              placeholder=" " />
            <label for="rproduct_shipping_per_gm"
              class="absolute text-sm lg:text-sm text-[#898989] duration-300 transform -translate-y-4 scale-75 top-2 z-0 origin-[0] bg-white px-1.5 peer-focus:px-1.5 peer-focus:text-c19725 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1">Shipping
              Per Gram <span class="text-red-500">*</span></label>
          </div>
          <!-- Validation Error (NO layout change) -->
          <div *ngIf="
      readyProductForm.get('rproduct_shipping_per_gm')?.invalid &&
      readyProductForm.get('rproduct_shipping_per_gm')?.touched
    " class="text-red-500 text-xs mt-1">
            *Shipping Per Gram is required
          </div>
        </div>

        <div class="col-span-1">
          <div class="relative">
            <input type="number" id="rproduct_other_expense_per_gm" formControlName="rproduct_other_expense_per_gm"
              (keydown.enter)="focusNext($event)" autocomplete="off"
              class="no-spinner block px-2 py-2 w-full text-sm lg:text-sm text-444 font-normal bg-white rounded-md border-1 border-dcdcdc appearance-none focus:outline-none focus:ring-0 focus:border-c19725 peer"
              placeholder=" " />
            <label for="rproduct_other_expense_per_gm"
              class="absolute text-sm lg:text-sm text-[#898989] duration-300 transform -translate-y-4 scale-75 top-2 z-0 origin-[0] bg-white px-1.5 peer-focus:px-1.5 peer-focus:text-c19725 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1">
              Expense Per Gram</label>
          </div>
        </div>

        <div class="col-span-1">
          <div class="relative">
            <input type="number" id="rproduct__per_gm_cost" formControlName="rproduct__per_gm_cost"
              (keydown.enter)="focusNext($event)" autocomplete="off"
              class="no-spinner block px-2 py-2 w-full text-sm lg:text-sm text-444 font-normal bg-white rounded-md border-1 border-dcdcdc appearance-none focus:outline-none focus:ring-0 focus:border-c19725 peer"
              placeholder=" " />
            <label for="rproduct__per_gm_cost"
              class="absolute text-sm lg:text-sm text-[#898989] duration-300 transform -translate-y-4 scale-75 top-2 z-0 origin-[0] bg-white px-1.5 peer-focus:px-1.5 peer-focus:text-c19725 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1">
              Per Gram Cost</label>
          </div>
        </div>

        <div class="col-span-1">
          <div class="relative">
            <input type="number" id="rproduct_cny_labour" formControlName="rproduct_cny_labour"
              (keydown.enter)="focusNext($event)" autocomplete="off"
              class="no-spinner block px-2 py-2 w-full text-sm lg:text-sm text-444 font-normal bg-white rounded-md border-1 border-dcdcdc appearance-none focus:outline-none focus:ring-0 focus:border-c19725 peer"
              placeholder=" " />
            <label for="rproduct_cny_labour"
              class="absolute text-sm lg:text-sm text-[#898989] duration-300 transform -translate-y-4 scale-75 top-2 z-0 origin-[0] bg-white px-1.5 peer-focus:px-1.5 peer-focus:text-c19725 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1">
              Add CNY Labour</label>
          </div>
        </div>

        <div class="col-span-1">
          <div class="relative">
            <input type="number" id="rproduct_total_wt" formControlName="rproduct_total_wt"
              (keydown.enter)="focusNext($event)"
              class="no-spinner px-2 py-2 w-full text-sm lg:text-sm text-444 font-normal bg-white rounded-md border-1 border-dcdcdc appearance-none focus:outline-none focus:ring-0 focus:border-c19725 peer"
              placeholder=" " autocomplete="off" [class.border-red-500]="
        readyProductForm.get('rproduct_total_wt')?.invalid &&
        readyProductForm.get('rproduct_total_wt')?.touched
      " />

            <label for="rproduct_total_wt" class="absolute text-sm lg:text-sm text-[#898989] duration-300 transform -translate-y-4 scale-75 top-2 z-0 origin-[0] bg-white px-1.5
      peer-focus:px-1.5 peer-focus:text-c19725
      peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2
      peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4
      rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1">
              Gross Weight ( in GM ) <span class="text-red-500">*</span>
            </label>
          </div>

          <!-- Validation Error (NO layout change) -->
          <div *ngIf="
      readyProductForm.get('rproduct_total_wt')?.invalid &&
      readyProductForm.get('rproduct_total_wt')?.touched
    " class="text-red-500 text-xs mt-1">
            *Gross weight is required
          </div>
        </div>

        <div class="col-span-1">
          <div class="relative">
            <input type="number" id="rproduct_total_panni_weight" formControlName="rproduct_total_panni_weight"
              (keydown.enter)="focusNext($event)" autocomplete="off"
              class="no-spinner block px-2 py-2 w-full text-sm lg:text-sm text-444 font-normal bg-white rounded-md border-1 border-dcdcdc appearance-none focus:outline-none focus:ring-0 focus:border-c19725 peer"
              placeholder=" " />
            <label for="rproduct_total_panni_weight"
              class="absolute text-sm lg:text-sm text-[#898989] duration-300 transform -translate-y-4 scale-75 top-2 z-0 origin-[0] bg-white px-1.5 peer-focus:px-1.5 peer-focus:text-c19725 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1">
              Silver Purity in % <span class="text-red-500">*</span></label>
          </div>
          <!-- Validation Error (NO layout change) -->
          <div *ngIf="
      readyProductForm.get('rproduct_total_panni_weight')?.invalid &&
      readyProductForm.get('rproduct_total_panni_weight')?.touched
    " class="text-red-500 text-xs mt-1">
            *Silver purity in % is required
          </div>
        </div>
        <div class="col-span-1">
          <div class="relative">
            <input readonly type="number" id="rproduct_net_weight" formControlName="rproduct_net_weight"
              (keydown.enter)="focusNext($event)"
              class="no-spinner px-2 py-2 w-full text-sm lg:text-sm text-444 font-semibold bg-[#F2F2F2] rounded-md border-1 border-dcdcdc appearance-none focus:outline-none focus:ring-0 focus:border-c19725 peer cursor-not-allowed"
              placeholder=" " autocomplete="off" />

            <label for="rproduct_net_weight"
              class="absolute font-semibold text-sm lg:text-sm text-444 duration-300 transform -translate-y-4 scale-75 top-2 z-0 origin-[0] bg-[#F2F2F2] px-1.5 peer-focus:px-1.5 peer-focus:text-c19725 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1">
              Fine Weight
            </label>
          </div>
        </div>
      </div>
    </div>

    <div class="w-full lg:w-full xl:w-1/3 mb-4 lg:mb-0">
      <div
        class="w-full bg-[#EEFFF4] p-3 rounded-md grid grid-cols-2 sm:grid-cols-3 gap-2 sm:gap-2.5 lg:gap-3 space-y-0.5 mb-4">
        <!-- <div class="col-span-1">
                      <app-custom-select label="Stone Type" [options]="stoneTypes" [(selected)]="selectedStoneType"  formControlName="rproduct_stonetype"
                      (keydown.enter)="focusNext($event)"
                          selectId="stoneTypes">
                      </app-custom-select>
                  </div> -->

        <div *ngIf="selectedStoneType === 'Mossenite'"
          class="col-span-1 md:col-span-2 xl:col-span-2 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-3 gap-2 sm:gap-2.5 lg:gap-3">
          <div class="col-span-1">
            <div class="relative">
              <input type="text" id="rproduct_carat" formControlName="rproduct_carat"
                (keydown.enter)="focusNext($event)" autocomplete="off"
                class="block px-2 py-2 w-full text-sm lg:text-sm text-444 font-normal bg-white rounded-md border-1 border-dcdcdc appearance-none focus:outline-none focus:ring-0 focus:border-c19725 peer"
                placeholder=" " />
              <label for="rproduct_carat"
                class="absolute text-sm lg:text-sm text-[#898989] duration-300 transform -translate-y-4 scale-75 top-2 z-0 origin-[0] bg-white px-1.5 peer-focus:px-1.5 peer-focus:text-c19725 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1">Carat</label>
            </div>
          </div>

          <div class="col-span-1">
            <div class="relative">
              <input type="number" id="rproduct_per_carat_price" formControlName="rproduct_per_carat_price"
                (keydown.enter)="focusNext($event)" autocomplete="off"
                class="no-spinner  px-2 py-2 w-full text-sm lg:text-sm text-444 font-normal bg-white rounded-md border-1 border-dcdcdc appearance-none focus:outline-none focus:ring-0 focus:border-c19725 peer"
                placeholder=" " />
              <label for="rproduct_per_carat_price"
                class="absolute text-sm lg:text-sm text-[#898989] duration-300 transform -translate-y-4 scale-75 top-2 z-0 origin-[0] bg-white px-1.5 peer-focus:px-1.5 peer-focus:text-c19725 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1">Per
                Carat Price</label>
            </div>
          </div>

          <div class="col-span-1">
            <div class="relative">
              <input type="number" id="rproduct_total_carat_price" formControlName="rproduct_total_carat_price"
                (keydown.enter)="focusNext($event)" autocomplete="off"
                class="no-spinner px-2 py-2 w-full text-sm lg:text-sm text-444 font-normal bg-white rounded-md border-1 border-dcdcdc appearance-none focus:outline-none focus:ring-0 focus:border-c19725 peer"
                placeholder=" " />
              <label for="rproduct_total_carat_price"
                class="absolute text-sm lg:text-sm text-[#898989] duration-300 transform -translate-y-4 scale-75 top-2 z-0 origin-[0] bg-white px-1.5 peer-focus:px-1.5 peer-focus:text-c19725 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1">Total
                Carat Price</label>
            </div>
          </div>
        </div>
        <div *ngIf="selectedStoneType === 'Other'" class="col-span-1">
          <div class="relative">
            <input type="number" id="rproduct_stone_price" formControlName="rproduct_stone_price"
              (keydown.enter)="focusNext($event)" autocomplete="off"
              class="no-spinner px-2 py-2 w-full text-sm lg:text-sm text-444 font-normal bg-white rounded-md border-1 border-dcdcdc appearance-none focus:outline-none focus:ring-0 focus:border-c19725 peer"
              placeholder=" " />
            <label for="rproduct_stone_price"
              class="absolute text-sm lg:text-sm text-[#898989] duration-300 transform -translate-y-4 scale-75 top-2 z-0 origin-[0] bg-white px-1.5 peer-focus:px-1.5 peer-focus:text-c19725 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1">Total
              Stone Price</label>
          </div>
        </div>

        <!-- <div class="col-span-1">
                      <app-custom-select label="Polish Type" [options]="polishType" [(selected)]="selectedPolish" formControlName="rproduct_polishtype"
                      (keydown.enter)="focusNext($event)"
                          selectId="polishType">
                      </app-custom-select>
                  </div> -->



        <!-- <div class="col-span-1">
          <app-custom-select label="Unit" [options]="saleUnit" [(selected)]="selectedSaleUnit"
            formControlName="rproduct_unit" (keydown.enter)="focusNext($event)" selectId="saleUnit">
          </app-custom-select>
        </div> -->

      </div>
    </div>
  </div>
  <!-- buttons -->
  <div class="flex items-center justify-center mt-4 md:mt-8 space-x-1.5 md:space-x-4">

    <button type="submit" *ngIf="submitButton"
      class="block cursor-pointer capitalize w-[140px] lg:w-[200px] p-1 md:p-1.5 text-base xl:text-lg font-bold text-white bg-c19725 border-1 border-c19725 hover:bg-fdffc6 hover:text-c19725 hover:shadow-lg focus:ring-0 focus:outline-none rounded-md text-center">Save<svg
        class="inline mx-1 sm:mx-2" width="12" height="13" viewBox="0 0 12 13" fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path d="M9.13125 7.25H0V5.75H9.13125L4.93125 1.55L6 0.5L12 6.5L6 12.5L4.93125 11.45L9.13125 7.25Z"
          fill="#ffffff" />
      </svg>New</button>


    <button type="button" (click)="UpdateReadyProduct()" *ngIf="updateButton"
      class="block cursor-pointer capitalize w-[140px] lg:w-[200px] p-1 md:p-1.5 text-base xl:text-lg font-bold text-white bg-c19725 border-1 border-c19725 hover:bg-fdffc6 hover:text-c19725 hover:shadow-lg focus:ring-0 focus:outline-none rounded-md text-center">Update</button>
  </div>
</form>
<div class="overflow-x-auto whitespace-nowrap hide-scrollbar mt-4">
  <table class="w-full table bg-white border border-[#D9D9D9] overflow-hidden">
    <thead class="bg-[#F1F8FF] border border-[#0C447D] text-444 text-xs sm:text-xs">
      <tr>
        <th class="p-2 font-medium text-center border-r border-[#0C447D]">No.</th>
        <th class="p-2 font-medium text-center border-r border-[#0C447D]">Category</th>
        <th class="p-2 font-medium text-center border-r border-[#0C447D]">Category Code</th>
        <th class="p-2 font-medium text-center border-r border-[#0C447D]">Lot Number</th>
        <!-- <th class="p-2 font-medium text-center border-r border-[#0C447D]">Supplier Name</th> -->
        <!-- <th class="p-2 font-medium text-left border-r border-[#0C447D]">Silver Rate per GM</th> -->
        <th class="p-2 font-medium text-left border-r border-[#0C447D]">Per GM Labour</th>
        <th class="p-2 font-medium text-left border-r border-[#0C447D]">Per GM Shipping</th>
        <th class="p-2 font-medium text-left border-r border-[#0C447D]">Expense Per GM</th>
        <th class="p-2 font-medium text-left border-r border-[#0C447D]">Per GM Cost</th>
        <th class="p-2 font-medium text-left border-r border-[#0C447D]">CNY Labour</th>
        <th class="p-2 font-medium text-left border-r border-[#0C447D]">Gross Weight</th>
        <th class="p-2 font-medium text-left border-r border-[#0C447D]">Silver Purity %</th>
        <th class="p-2 font-medium text-left border-r border-[#0C447D]">Fine Weight</th>
        <th class="p-2 font-medium text-left border-r border-[#0C447D]"> Unit</th>
        <th class="p-2 font-medium text-center">Date</th>
      </tr>
    </thead>
    <tbody class="text-xs sm:text-xs">
      <tr class="odd:bg-white even:bg-[#F2F2F2] text-[#5A5959]"
        *ngFor="let metal of readyProductDataList; let i = index">
        <td class="p-3 text-center">{{ i + 1 }}</td>
        <td class="p-3">{{ metal?.rproduct_categories?.name || '-'}} ({{ metal?.rproduct_categories?.unit || '-'}})</td>
        <td class="p-3">{{ metal?.rproduct_categories?.code || '-'}}</td>
        <td class="p-3">{{ metal.rproduct_code || '-'}}</td>
        <!-- <td class="p-3">{{ metal?.rproduct_supplier_name || '-' }}</td> -->
        <!-- <td class="p-3">{{ metal.rproduct_silver_rate_per_gm || '-'}}</td> -->
        <td class="p-3">{{ metal.rproduct_per_gram_labour || '-'}}</td>
        <td class="p-3">{{ metal.rproduct_shipping_per_gm || '-'}}</td>
        <td class="p-3">{{ metal.rproduct_other_expense_per_gm || '-'}}</td>
        <td class="p-3">{{ metal.rproduct__per_gm_cost || '-'}}</td>
        <td class="p-3">{{ metal.rproduct_cny_labour || '-'}}</td>
        <td class="p-3">{{ metal.rproduct_total_wt || '-'}}</td>
        <td class="p-3">{{ metal.rproduct_total_panni_weight || '-'}}</td>
        <td class="p-3">{{ metal.rproduct_net_weight || '-'}}</td>
        <td class="p-3">{{ metal.rproduct_unit || '-'}}</td>

        <td class="p-3 text-center">{{ metal.rproduct_date | date: 'dd-MM-yyyy' }}</td>
      </tr>
    </tbody>
  </table>
</div>